import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-trade-in-banner',
  templateUrl: './trade-in-banner.component.html',
  styleUrls: ['./trade-in-banner.component.scss']
})
export class TradeInBannerComponent implements OnInit {
  ENV: string = '';
  constructor(private UTS: UtilitiesService) { }

  ngOnInit(): void {
    
  }
  goToTradeInPage(){
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      if (OS == 'Android') {
        (window as any).deals.openTradeIn();
      } else {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage('openTradeIn');
      }
    }
    else {
      const lang = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
      window.open( environment.HOST + `/b2c/eshop/trade_in?locale=${lang}`, '_blank');
    }
  }
}
